import { Flex, Typography } from '@aircall/tractor-v2';
import { UserAvatar } from '@components/UserAvatarV2';
import { getInitials } from '@dashboard/library';
import { UserMinimalFragment } from '@generated/UserMinimalFragment';

export function ColumnFieldName({ firstName, ID, lastName, pictureURL }: UserMinimalFragment) {
  const initials = getInitials(firstName, lastName);

  return (
    <Flex alignItems='center'>
      <UserAvatar initials={initials} size='regular' src={pictureURL} id={ID} />
      <Typography ml='8px' variant='bodyRegularS' color='text-base' ellipsis maxW='600px'>
        {firstName} {lastName}
      </Typography>
    </Flex>
  );
}
